import validate from "/home/runner/work/nuxt.com/nuxt.com/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@22.15.19_better-sqlite3@11.10.0_db0@0.3.2_f173198be2f25f999a8e66ee2a80f293/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/runner/work/nuxt.com/nuxt.com/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.1_@types+node@22.15.19_better-sqlite3@11.10.0_db0@0.3.2_f173198be2f25f999a8e66ee2a80f293/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}